import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';

const WorkspaceThumbnail = ({ 
    imageUrl, 
    className, 
    style = { maxWidth: 40, maxHeight: 40 } 
}) => {
    const [cachedSrc, setCachedSrc] = useState(null);

    useEffect(() => {
        if (!imageUrl) return;
        
        const img = new window.Image();
        img.src = imageUrl;
        img.onload = () => setCachedSrc(imageUrl);
    }, [imageUrl]);

    return (
        <Image 
            src={cachedSrc || imageUrl} 
            className={className} 
            style={style} 
            alt="Workspace Thumbnail" 
            rounded
        />
    );
};

export { WorkspaceThumbnail };